import { OverlayTrigger, Tooltip } from "react-bootstrap";

export const codeTemplate = (node: any): any => {
	const maxCodeLength = 8;

	if (node.data?.code?.length > maxCodeLength) {
		return (
			<OverlayTrigger
				placement="top"
				overlay={<Tooltip>{node.data.code}</Tooltip>}
			>
				<span>
					{node.data.code.substring(0, maxCodeLength) + "..."}
				</span>
			</OverlayTrigger>
		);
	} else {
		return <span>{node.data?.code ?? ""}</span>;
	}
};
